module.exports = __webpack_public_path__ + "img/x-logo.11a3088e.svg";